module.exports = __webpack_public_path__ + "static/media/YoutubeLogo.75a8bc32.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Nav/YoutubeLogo.svg
// module id = 50
// module chunks = 0